module.exports = __webpack_public_path__ + "img/return.58f33af9.svg";